// components/misc/Workflow/TriggerNode.js
import React from "react";
import { Handle, Position } from "reactflow";

const TriggerRequestNode = React.forwardRef(({ data, isConnectable }, ref) => {
    const handleStyle = {
        backgroundColor: "black",
        width: "2px",
        height: "2px",
        border: "1px solid #ccc",
        cursor: "pointer",
    };

    const bottomHandleStyle = {
        ...handleStyle,
        transform: "translateY(20px) translateX(-50%)"
    };

    const handleClick = (event) => {
        if (data.onClick) {
            data.onClick(event, data.id);
        }
    };

    const addBtnStyle = {
        borderRadius: "50%",
        width: "20px",
        height: "20px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        border: "1px solid #0000FF",
        backgroundColor: "#fff",
        color: "#0000FF",
        fontSize: "10px",
        lineHeight: "1",
    };

    const onAddNextActionClick = (event) => {
        event.stopPropagation(); // Prevent the click from propagating to the node
        if (data.onAddNextActionClick) {
            data.onAddNextActionClick(event, data.id);
        }
    };

    return (
        <div className="flex flex-col items-center justify-center">
            <div
                onClick={handleClick}
                ref={ref}
                className="relative w-[140px] rounded-md border border-gray-800 bg-white p-1 text-center text-gray-900"
            >
                <Handle
                    type="source"
                    position={Position.Bottom}
                    id="b"
                    isConnectable={isConnectable}
                    style={bottomHandleStyle} // Apply the bottomHandleStyle here
                />
                <div
                    title={data.label}
                    className="overflow-hidden text-ellipsis whitespace-nowrap text-[0.5rem]"
                >
                    {data.label}
                </div>
            </div>
            <div onClick={onAddNextActionClick} style={addBtnStyle}>
                +
            </div>
        </div>
    );
});

export default TriggerRequestNode;
